import React, { useContext, useState } from 'react';
import { MiFooter } from "../../components/footer/MiFooter";
import { ContentPresupuestos } from '../../components/Presupuestos/ContentPresupuestos';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { ModalEnviarPresupuesto } from '../../components/Presupuestos/ModalEnviarPresupuesto';
import './Presupuestos.css';
import HeaderHome from '../../components/headerHome/HeaderHome';

export const Presupuestos = () => {


  const [MenuLateralAux, setMenuLateralAux] = useState(false);


  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }
  return (
    <>

    <div className="Presupuestos" >
        <div className="headerPresupuestos">
          <HeaderHome
            chageMenuLateralAux={chageMenuLateralAux}
          />
        </div>
        <div className="bodyPresupuestos">
            <ContentPresupuestos
            MenuLateralAux={MenuLateralAux}
            chageMenuLateralAux={chageMenuLateralAux}
            />
        </div>
        <div className="footerPresupuestos">
            <MiFooter/>
        </div>
    </div>
    </>
  )
}
